// apps/admin-ui/src/config/api.ts
// Single source of truth for all backend URLs.
//
// In production builds, VITE_API_GATEWAY is set in .env.production
// (e.g. https://api.cxxr.net) and every service URL falls back to
// a path under that gateway. Individual VITE_*_URL overrides are
// still honoured if present.
// ALL RIGHTS RESERVED

const GATEWAY = import.meta.env.VITE_API_GATEWAY || '';

export const API_CONFIG = {
  /** IDP base — NOTE: includes /api/v1 suffix (auth.ts appends /employee/login) */
  idp:        import.meta.env.VITE_IDP_URL        || `${GATEWAY}/idp/api/v1`,
  /** Ledger reporting API */
  ledger:     import.meta.env.VITE_API_URL         || `${GATEWAY}/ledger`,
  /** Governance + threats */
  governance: import.meta.env.VITE_GOVERNANCE_URL  || `${GATEWAY}/governance`,
  /** Exchange admin */
  exchange:   import.meta.env.VITE_EXCHANGE_URL    || `${GATEWAY}/exchange`,
  /** KYC widgets */
  kyc:        import.meta.env.VITE_KYC_URL         || `${GATEWAY}/kyc`,
} as const;
